import { Category } from '../../../../types/organization/category';

import { Visit } from '@/features/visits/api/types/visits';

export interface Visitor {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  arrivedAt: number | null;
  leftAt: number | null;
  isPregnant: boolean;
  isHandicapped: boolean;
  hasAccessToParking: boolean;
  state: string;
  vehicleLicensePlate: string | null;
  visitId: number;
  visit: Visit;
  organizationId: number;
}

export type VisitSource = 'Host' | 'Kiosk' | 'Organization' | 'Reception';

export const VISITOR_LANGUAGE = {
  POLISH: 'pl',
  ENGLISH: 'en',
} as const;

export type VisitorLanguage = (typeof VISITOR_LANGUAGE)[keyof typeof VISITOR_LANGUAGE];

export interface VisitorMeili {
  arrivedAt: number;
  description: string;
  email: string;
  firstName: string;
  hasAccessToParking: boolean;
  id: string;
  isHandicapped: boolean;
  isPregnant: boolean;
  lastName: string;
  leftAt: number;
  organizationId: number;
  siteId: number;
  state: string;
  vehicleLicensePlate: string;
  visitAdditionalDestinationIds: number[];
  visitAdditionalDestinations: {
    name: string;
    description: string;
    floor: string;
    directionTip: string;
    maxCapacity: number;
  }[];
  visitCreatedAt: number;
  visitDescription: string;
  visitExpectedAt: number;
  visitFinishesAt: number;
  visitHost: {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    allowInviteToParking: boolean;
  };
  visitHostId: number;
  visitId: number;
  visitMainDestination: {
    name: string;
    description: string;
    floor: string;
    directionTip: string;
    maxCapacity: number;
  };
  visitMainDestinationId: number;
  visitNumberOfVisitors: number;
  visitState: string;
  visitCategory: Category;
  visitSource?: VisitSource;
  visitHostConfirmed?: boolean | null;
  visitKioskEnteredHostName?: string | null;
  visitDeviceConfirmed?: boolean | null;
}

export interface CreateVisitor {
  firstName: string;
  lastName: string;
  email: string;
  isHandicapped: boolean;
  isPregnant: boolean;
  hasAccessToParking: boolean;
  discountTemplateId?: number;
  hasPet: boolean;
  description: string;
  language: VisitorLanguage;
}
